import { Card, fontSmall } from "swing-components";

import { Chip, ChipProps, ProgressIcon, ProgressIconProps } from "~components";

import "./TaskCardBase.css";

export type TaskCardBaseProps = {
  /**
   * Optional object containing props for the ProgressIcon
   * If this is not passed the Icon will not be rendered
   */
  progressIcon?: ProgressIconProps;
  /**
   * Bolded text
   */
  title: string;
  /**
   * Smaller text
   */
  description: string;
  /**
   * Optional object containing props for the Chip
   * If this is not passed the Chip will not be rendered
   */
  chip?: Omit<ChipProps, "icon">;
  onClick?: () => void;
};

export function TaskCardBase(props: TaskCardBaseProps) {
  const { progressIcon, title, description, chip, onClick } = props;

  return (
    <Card onClick={onClick}>
      <div
        css={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
          minHeight: 120,
        }}
      >
        {progressIcon && (
          <ProgressIcon
            icon={progressIcon.icon}
            percentage={progressIcon.percentage}
            color={progressIcon.color}
          />
        )}
        <div css={{ marginLeft: "16px", display: "flex", flexDirection: "column", gap: 8 }}>
          <p css={{ ...fontSmall({ fontWeight: 600 }), margin: 0 }}>{title}</p>
          <p css={{ ...fontSmall(), margin: 0 }}>{description}</p>
          {chip && <Chip color={chip.color} label={chip.label} />}
        </div>
      </div>
    </Card>
  );
}
